export default {
  blends: {
    validationMessage:{
      requiredMessage:'Sehemu hii inahitajika.',
      isNumber:'Lazima iwe nambari.',
      isValidNumber:'Lazima iwe nambari halali.',
      noNegativeNumbers:'Thamani hii haitakiwi kuwa hasi.',
      atLeastTwoProducts:'Angalau bidhaa mbili zinahitajika',
    },
    exemptProducts: {
      eudrExemptProducts: 'Bidhaa Zisizohusishwa na EUDR',
      addEUDRExemptProduct: 'Ongeza Bidhaa Isiyohusishwa na EUDR',
      updateEUDRExemptProduct: 'Sasisha Bidhaa Isiyohusishwa na EUDR',
      internalRefNumber: 'Nambari ya Marejeo ya Ndani',
      supplier: 'Muuzaji',
      containerID: 'ID ya Kontena',
      product: 'Bidhaa',
      quantity: 'Kiasi',
      dateAdded: 'Tarehe Iliyoongezwa',
      addProduct: 'Ongeza Bidhaa',
      selectDate: 'Chagua Tarehe',
      addContainer: 'Ongeza Kontena',
      containerInformation: 'Taarifa za Kontena',
      supplierInformation: 'Taarifa za Muuzaji',
      supplierInformationTT: 'Maelezo kuhusu chombo kinachotoa bidhaa au huduma.',
      supplierTooltip:
        'Chagua muuzaji kutoka kwenye orodha iliyosajiliwa awali katika mfumo.',
      addnewSupplier: 'Ongeza Muuzaji Mpya',
      internalReferenceNumberMustBeAlphanumeric:
        'Nambari ya marejeo ya ndani lazima iwe alfanumeriki',
      netMassMustBeValid: 'Uzito halisi lazima uwe halali',
      volumeMustBeNumeric: 'Kiasi lazima kiwe namba',
      subProduct: 'Bidhaa Ndogo',
      netMass: 'Uzito Halisi',
      volume: 'Kiasi',
      productDetail: 'Maelezo ya Bidhaa',
      placeOfActivity: 'Mahali pa Shughuli',
      countryOfActivity: 'Nchi ya Shughuli',
      countryOfEntry: 'Nchi ya Kuingia',
      activity: 'Shughuli',
      internalRefNo: 'Nambari ya Marejeo ya Ndani',
      name: 'Jina',
      email: 'Barua Pepe',
      phoneNumber: 'Nambari ya Simu',
      country: 'Nchi',
      status: 'Hali',
      addNewSupplier: 'Ongeza Muuzaji Mpya',
      availableForBlends: 'Inapatikana kwa Mchanganyiko',
      thisFieldIsRequired: 'Sehemu hii inahitajika.',
      enterSupplierFirstName: 'Ingiza Jina la Kwanza la Muuzaji',
      enterSupplierLastName: 'Ingiza Jina la Mwisho la Muuzaji',
      enterEmailAddress: 'Ingiza Anwani ya Barua Pepe',
      enterPhoneNumber: 'Ingiza Nambari ya Simu',
      selectCountry: 'Chagua Nchi',
      firstNameIsRequired: 'Jina la kwanza linahitajika',
      lastNameIsRequired: 'Jina la mwisho linahitajika',
      unAvailableForBlends: 'Haipatikani kwa Mchanganyiko',
      exemptAddedSuccessfully:
        'Bidhaa isiyohusishwa na EUDR imeongezwa kwa mafanikio!',
      unExpectedErrorMsg:
        'Hitilafu isiyotazamiwa imetokea. Tafadhali jaribu tena.',
      availabilityStatusMsg:
        'Hali ya upatikanaji kwa mchanganyiko imesasishwa kwa mafanikio.',
      updateProduct: 'Sasisha Bidhaa',
      exemptUpdatedSuccessfully:
        'Bidhaa isiyohusishwa na EUDR imesasishwa kwa mafanikio!',
      invalidNumericValue: 'Thamani ya nambari si halali',
      containerIDTT:
        'Hii ni kitambulisho cha kipekee cha Kontena. Tafadhali weka ID ya Kontena hapa chini.',
        actions:'Vitendo',
    },
  
    blends: 'Mchanganyiko',
    blendSetting: 'Mipangilio ya Mchanganyiko',
    createBlendDds: 'Unda Mchanganyiko Dds',
    country: 'Nchi',
    countryTT: 'Nchi',
    select: 'Chagua',
    edurDueDeligenceStatus: 'Hali ya Ufuatiliaji wa EUDR',
    dueDiligenceStatus: 'Hali ya Ufuatiliaji',
    EUDRDeforestationStatusTT: 'Hali ya Ukataji Miti wa EUDR',
    dueDeligenceStatus: 'Hali ya Ufuatiliaji',
    uploadedToEU: 'Imepakiwa kwa EU',
    pending: 'Inasubiri',
    underReview: 'Inakaguliwa',
    compliant: 'Inakubaliana',
    nonCompliant: 'Haikubaliki',
    processingFarm: 'Shamba linalosindika',
    analyzingDeforestation: 'Kuchambua Ukataji Miti',
    writingToBlockchain: 'Kuandika kwenye Blockchain',
    readyToProceed: 'Tayari Kuendelea',
    mitigationRequired: 'Inahitaji Mitihani',
    viewReport: 'Tazama Ripoti',
    share: 'Shiriki',
    copyAndCreateNew: 'Nakili na Unda Mpya',
    remove: 'Ondoa',
    eudrRefNo: 'Nambari ya Marejeo ya Ndani/EUDR',
    finalProduct: "Jina la Mchanganyiko & ID ya Loti ya Mchanganyiko",
    noOfIngredients: 'Idadi ya Viungo',
    farmsAndQuantity: 'Mashamba & Kiasi',
    actions: 'Vitendo',
    confirmDialog: {
      delete: {
        title: 'Futa Mchanganyiko',
        message: 'Una uhakika unataka kufuta Mchanganyiko huu?',
        confirmBtn: 'Thibitisha',
        cancelBtn: 'Ghairi',
      },
    },
    searchBlend: 'Tafuta Mchanganyiko kwa Bidhaa ya Mwisho',
    blendDuplicatedSuccessfully: 'Mchanganyiko umefanikiwa kuiga.',
    reportDeletedSuccessfully: 'Ripoti imefutwa kwa mafanikio.',
    
    blendSettings: {
      dashboard: 'Dashibodi',
      blendSettings: 'Mipangilio ya Mchanganyiko',
      importBlends: 'Ingiza Mchanganyiko',
      addNewBlend: 'Ongeza Mchanganyiko Mpya',
      searchTitle: 'Tafuta kwa Kichwa cha Mchanganyiko',
      view: 'Tazama',
      edit: 'Hariri',
      remove: 'Ondoa',
      farms: 'Fazendas',
      blendCode: 'Msimbo wa Mchanganyiko',
      blendTitle: 'Kichwa cha Mchanganyiko',
      description: 'Maelezo',
      'finalProductName&Code': 'Jina na Msimbo wa Bidhaa ya Mwisho',
      dateAdded: 'Tarehe Iliyoongezwa',
      actions: 'Vitendo',
      addBlend: 'Ongeza Mipangilio ya Mchanganyiko',
      cancel: 'Ghairi',
      createBlend: 'Unda Mchanganyiko',
      generalData: 'Takwimu za Jumla',
      generalDataTT: "Lebo hii inaonyesha data zote kwenye skrini.",
      blendTitleTT: "Menyu ya kushuka inaweza kufikiwa kwa kubofya, ambayo inaonyesha orodha ya mchanganyiko unaopatikana kwa kuchagua.",
      enterHere: 'Ingiza hapa',
      blendCodeTT: 'Msimbo wa Mchanganyiko',
      blendDescription: 'Maelezo ya Mchanganyiko',
      blendDescriptionTT: 'Maelezo ya Mchanganyiko',
      finalProductName: 'Jina la Bidhaa ya Mwisho',
      finalProductNameTT: 'Jina la Bidhaa ya Mwisho',
      finalProductCode: 'Msimbo wa Bidhaa ya Mwisho',
      finalProductCodeTT: 'Msimbo wa Bidhaa ya Mwisho',
      processType: 'Aina ya Mchakato',
      processTypeTT: 'Aina ya Mchakato',
      finalProductLotIdGen: 'Kizazi cha ID ya Sehemu ya Bidhaa ya Mwisho',
      finalProductLotIdGenTT: 'Kizazi cha ID ya Sehemu ya Bidhaa ya Mwisho',
      productDetails: 'Bidhaa za Mchanganyiko (Viungo)',
      productDetailsTT: 'Bidhaa za Mchanganyiko (Viungo)',
      selectType: 'Chagua Aina',
      startCount: 'Hesabu ya Mwanzo',
      resetCounterEach: 'Weka Upya Kaunta Kila',
      enter: 'Ingiza',
      staticText: 'Maandishi Tulivu',
      incrementalNumber: 'Nambari ya Kuongezeka',
      year: 'Mwaka',
      month: 'Mwezi',
      date: 'Tarehe',
      none: 'Hakuna',
      space: 'Nafasi',
      '0001': '0001',
      resetCounter: 'Weka upya kaunta kila',
      selectSeparator: 'Chagua Kitenganishi',
      previewLotId: 'Onyesho la Awali la ID ya Sehemu',
      blendProducts: 'Bidhaa za Mchanganyiko',
      blendProductsTT: 'Bidhaa za Mchanganyiko',
      product: 'Bidhaa',
      productTT: 'Bidhaa',
      selectProduct: 'Chagua Bidhaa',
      subProduct: 'Bidhaa Ndogo',
      subProductTT: 'Bidhaa Ndogo',
      selectSubProduct: 'Chagua Bidhaa Ndogo',
      originCountry: 'Nchi ya Asili',
      originCountryTT: 'Nchi ya Asili',
      selectCountry: 'Chagua Nchi',
      percentage: 'Asilimia',
      percentageTT: 'Asilimia',
      addAnotherProduct: 'Ongeza Bidhaa Nyingine',
      confirmation: 'Uthibitisho',
      createBlendMessage: 'Una uhakika unataka kuongeza mchanganyiko mpya?',
      updateBlendMessage: 'Una uhakika unataka kusasisha mchanganyiko huu?',
      confirm: 'Thibitisha',
      pleaseFillRequiredFields: 'Tafadhali jaza sehemu zinazohitajika',
      lightRoast: 'Kavukavu Nyepesi',
      mediumRoast: 'Kavukavu ya Kati',
      mediumDarkRoast: 'Kavukavu Kati-Giza',
      darkRoast: 'Kavukavu Giza',
      validation: {
        titleRequired: 'Kichwa kinahitajika',
        codeRequired: 'Msimbo wa mchanganyiko unahitajika',
        descriptionRequired: 'Maelezo yanahitajika',
        finalProductNameRequired: 'Jina la bidhaa ya mwisho linahitajika',
        finalProductCodeRequired: 'Msimbo wa bidhaa ya mwisho unahitajika',
        processTypeRequired: 'Aina ya mchakato inahitajika',
        selectTypeRequired: 'Aina inahitajika',
        startCountRequired: 'Hesabu ya mwanzo inahitajika',
        selectSeparatorRequired: 'Kitenganishi kinahitajika',
        finalProductLotIdGenRequired:
          'Kizazi cha ID ya sehemu ya bidhaa ya mwisho kinahitajika',
        productRequired: 'Bidhaa inahitajika',
        subProductRequired: 'Bidhaa ndogo inahitajika',
        originCountryRequired: 'Nchi ya asili inahitajika',
        percentageRequired: 'Asilimia inahitajika',
        hundredPrecent: 'Jumla ya asilimia inapaswa kuwa 100% kamili',
        productSubproductDuplicatedMsg: 'Bidhaa na bidhaa ndogo zimejirudia',
      },
      mustSelectIncrementalNumber:
        'Angalau nambari moja ya kuongezeka inahitajika',
      blendSettingsCreated: 'Mipangilio ya mchanganyiko imeundwa kwa mafanikio.',
      blendSettingsNotCreated:
        'Uundaji wa mipangilio ya mchanganyiko haukufaulu. Jaribu tena kwa data sahihi.',
      confirmDiaglog: {
        delete: {
          title: 'Futa',
          message: 'Una uhakika unataka kufuta mipangilio hii ya mchanganyiko?',
          confirmBtn: 'Thibitisha',
          cancelBtn: 'Ghairi',
        },
      },
      itemDeletedSuccessfully:
        'Mipangilio ya mchanganyiko imefutwa kwa mafanikio',
      updateBlend: 'Sasisha Mipangilio ya Mchanganyiko',
      save: 'Hifadhi',
      blendSettingsUpdated:
        'Mipangilio ya mchanganyiko imesasishwa kwa mafanikio.',
      blendSettingsNotUpdated:
        'Usasishaji wa mipangilio ya mchanganyiko haukufaulu. Jaribu tena kwa data sahihi.',
      updateMessage: 'Una uhakika unataka kusasisha mchanganyiko huu?',
      createMessage: 'Una uhakika unataka kuongeza mchanganyiko mpya?',
      finalProductCodeAlreadyExists: 'Msimbo wa bidhaa ya mwisho tayari upo',
      blendCodeAlreadyExists: 'Msimbo wa mchanganyiko tayari upo.',
      valueMustBeNumber: 'Thamani lazima iwe nambari',
      valueMustBeNonNegative: 'Thamani hii lazima iwe kubwa kuliko sifuri',
    },
    imports: {
      imports: 'Uingizaji',
      blends: 'Mchanganyiko',
      createNewImport: 'Unda Uingizaji Mpya',
      importsBlends: 'Ingiza Mchanganyiko',
      createBlends: 'Unda Mchanganyiko',
      downloadTemplateInfo:
        'Pakua na tumia templeti zilizo hapa chini ili kuingiza geofences kwa wingi.',
      selectTemplate: 'Chagua Templeti',
      downloadXlsTemplate: 'Pakua Umbizo la Templeti ya Uingizaji wa XLS',
      downloadProductCodes: 'Pakua Misimbo ya Bidhaa',
      selectFileToUpload: 'Chagua faili kupakia data',
      orDragDrop: 'Au buruta na uachilie faili hapa',
      removeFile: 'Ondoa Faili',
      importantNote: 'Kumbuka Muhimu',
      templateNote:
        'Tafadhali tumia templeti zilizo hapo juu kwa upakiaji wa wingi. Umbizo jingine litasababisha kushindwa.',
      importData:'Hakikisha kuwa data hizi hazitahifadhiwa mpaka hali zote zifanikiwe.',
      fileUploadSuccess: 'Faili imepakiwa kwa mafanikio',
      invalidFileFormat:
        'Umbizo la faili si sahihi. Tafadhali pakia faili halali',
      pleaseSelectSource: 'Tafadhali chagua angalau chanzo kimoja',
      blendTitle: 'Kichwa cha Mchanganyiko',
      blendCode: 'Msimbo wa Mchanganyiko',
      finalProductCode: 'Msimbo wa Bidhaa ya Mwisho',
      finalProductName: 'Jina la Bidhaa ya Mwisho',
      status: 'Hali',
      downloadCsvTemplate: 'Pakua Umbizo la Templeti ya CSV',
      dropHere: 'au buruta na uachilie hapa',
      Importing: 'Inapakia...',
      modalMessage:
        'Faili yako iliyopakiwa inachakatwa kwa sasa. Tutakujulisha baada ya faili kupakiwa kwa mafanikio.',
      importXLSFormat: 'Ingia Umbizo la XLS',
      importCSVFormat: 'Ingia Umbizo la CSV',
      fileSelected: 'Faili limechaguliwa kwa mafanikio.',
      success: 'Data imeingizwa kwa mafanikio.',
      importCompleted: 'Uingizaji Umefanikiwa',
      invalidHeaders: "Vichwa vya Faili si Sahihi",
      headerMismatchErro: "Faili lililopakiwa lazima liwe na vichwa vifuatavyo",
      missingHeaders: "Vichwa Vilivyokosekana",
      additionalHeaders: "Vichwa vya Ziada (haviruhusiwi)"
    },
    history: {
      history: 'Historia',
      fileName: 'Jina la Faili',
      importedOn: 'Imeingizwa Tarehe',
      status: 'Hali',
      action: 'Kitendo',
      blends: 'Mchanganyiko',
      download: 'Pakua',
      success: 'Mafanikio',
      failed: 'Imeshindikana'
    },
    createBlends: {
      eudrDueDiligence: 'Ufuatiliaji wa EUDR',
      createBlends: 'Unda Mchanganyiko',
      discard: 'Ondoa',
      reject: 'Kataa',
      saveAndContinueLater: 'Hifadhi na Endelea Baadaye',
      generateReport: 'Tengeneza Ripoti',
      generalData: 'Takwimu za Jumla',
      blend: 'Mchanganyiko',
      selectBlend: 'Chagua Mchanganyiko',
      blendCode: 'Msimbo wa Mchanganyiko',
      blendDescription: 'Maelezo ya Mchanganyiko',
      finalProduct: 'Bidhaa ya Mwisho',
      finalProductCode: 'Msimbo wa Bidhaa ya Mwisho',
      netMass: 'Uzito Halisi',
      netMassTT: "Huruhusu watumiaji kuingiza thamani ya kodi ya uzito halisi inayohusiana na bidhaa, usafirishaji, au muamala.",
      volume: 'Kiasi',
      volumeTT: "Lebo inaonyeshwa kwa uwazi karibu na sehemu au uwanja ambapo data inayohusiana na ujazo inaonyeshwa au kuingizwa, kama vile kwenye vipimo vya bidhaa au fomu za usafirishaji.",
      blendLotId: 'ID ya Sehemu ya Mchanganyiko',
      blendLotIdTT: "Inaonyesha kitambulisho cha kipekee cha kundi kulingana na usanidi wa mipangilio ya Blend kwa kufuatilia kundi la mchanganyiko.",
      finishedProductLotId: 'ID ya Sehemu ya Bidhaa ya Mwisho',
      finishedProductLotIdTT: "Ingiza kitambulisho cha kipekee cha kundi kwa kufuatilia kundi la mwisho la bidhaa.",
      enterHere: 'Ingiza Hapa',
      internalReferenceNumber: 'Nambari ya Marejeo ya Ndani',
      internalReferenceNumberTT: "Msimbo wa rejea wa ndani kwa madhumuni ya ufuatiliaji.",
      eudrReferenceNumber: 'Nambari ya Marejeo ya EUDR',
      eudrReferenceNumberTT: "Msimbo wa rejea wa ufuatiliaji wa EUDR (Kanuni ya Ukataji miti wa Umoja wa Ulaya). Hii itajazwa moja kwa moja ikiwa mtumiaji atataka kupakia kwa EUDR baada ya kuunda ripoti.",
      companyId: 'ID ya Kampuni',
      companyIdTT: "Kitambulisho cha kampuni inayohusiana na mchanganyiko huu.",
      activity: 'Shughuli',
      domestic: 'Ndani',
      import: 'Ingiza',
      export: 'Hamisha',
      containerInformation: 'Taarifa za Kontena',
      containerInformationTT: "Hii ni kitambulisho cha kipekee cha Kontena. Tafadhali weka Kitambulisho cha Kontena hapa chini.",
      addContainer: 'Ongeza Kontena',
      blendProduct: 'Bidhaa ya Mchanganyiko',
      blendProductTT: "Ongeza Bidhaa na Bidhaa Ndogo nyingi kutoka kwa Bidhaa Zisizoathiriwa za DDS/EUDR kwa kuunda Mchanganyiko.",
      product: 'Bidhaa',
      productTT: "Huonyesha watumiaji bidhaa iliyochaguliwa kutoka kwenye orodha ya bidhaa zinazopatikana katika Mipangilio ya Mchanganyiko kwa ajili ya usindikaji, uchambuzi, au kuripoti ndani ya programu, kuwezesha uingizaji na usimamizi sahihi wa data.",
      subProduct: 'Bidhaa Ndogo',
      subProductTT: "Huonyesha watumiaji bidhaa ndogo zilizochaguliwa kutoka kwenye bidhaa ndogo zinazopatikana katika Mipangilio ya Mchanganyiko zinazohusiana na bidhaa kuu iliyochaguliwa, kuwezesha uingizaji na usimamizi wa kina wa data ndani ya programu.",
      ddsId: 'ID ya DDS',
      containerId: 'ID ya Kontena',
      uniqueContainerId:"Kitambulisho cha Kontena lazima kiwe cha kipekee",
      containerIdTT: "Kitambulisho cha kipekee kwa kontena linalobeba mchanganyiko huu.",
      country: 'Nchi',
      countryTT: "Chagua nchi inayohusiana na asili au mahali pa kuelekea kwa mchanganyiko.",
      search: 'Tafuta',
      select: 'Chagua',
      addAnotherProduct: 'Ongeza Bidhaa Nyingine',
      customization: 'Ubinafsishaji',
      recordsPerPage: 'Rekodi kwa Ukurasa',
      restoreDefault: 'Rejesha Chaguomsingi',
      apply: 'Tumia',
      applyFilter:"Tumia Kichujio",
      clearFilter:"Futa Kichujio",
      status: {
        compliant: 'Inakubaliana',
        nonCompliant: 'Haikubaliki',
        uploadToEudr:"IMEWEKWA KWENYE PORTALI YA EU",
        eudrExempt: "IMEONDOLEWA EUDR",
      },
      table: {
        eudrInternalRef: 'EUDR / Nambari ya Marejeo ya Ndani',
        containerId: 'ID ya Kontena',
        product: 'Bidhaa',
        farmsQuantity: 'Mashamba & Kiasi',
        submissionDate: 'Tarehe ya Uwasilishaji',
        dueDiligenceStatus: 'Hali ya Ufuatiliaji',
        availabilityForBlends: 'Upatikanaji kwa Mchanganyiko',
        pleaseSelectSource: 'Tafadhali chagua angalau chanzo kimoja',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Mahali pa Uzalishaji na Kitambulisho cha Shamba',
        product: 'Bidhaa',
        producerName: 'Jina la Mtengenezaji',
        addressOfProduction: 'Anwani ya Uzalishaji',
        status: 'Hali ya Ukataji Miti wa EUDR',
        riskAssessment: 'Tathmini ya Hatari',
      },      
      addNewSupplier: 'Ongeza Muuzaji Mpya',
      addNewBlend: 'Ongeza Mchanganyiko Mpya',
      placeOfActivity: 'Mahali pa Shughuli ya Opereta',
      placeOfActivityTT: "Taja nchi ya opereta ambapo shughuli zinafanyika na nchi ambako bidhaa itaingia kwenye soko la EU. Maelezo haya ni muhimu kwa kuhakikisha ufuatiliaji wa mahitaji ya EUDR.",
      countryOfActivity: 'Nchi ya Shughuli ya Opereta',      
      countryOfActivityTT: "Chagua nchi ambapo shughuli hii inafanyika.",
      countryOfEntry: 'Nchi ya Kuingia',
      countryOfEntryTT: "Chagua nchi ya kuingilia kwa bidhaa zilizoagizwa kutoka nje.",
      pleaseSelectAtLeastOne: 'Tafadhali chagua angalau ripoti moja ya kila bidhaa',
      blendCreatedSuccessfully: "Blend imeundwa vizuri.",
      blendCreateFailed: "Kulikuwa na hitilafu wakati wa kuunda blend.",
      blendUpdatedSuccessfully: "Blend imeboreshwa vizuri.",
      blendUpdateFailed: "Kulikuwa na hitilafu wakati wa kuboresha blend.",
      blendDeletedSuccessfully: "Blend imefutwa vizuri.",
      blendSavedSuccessfully: 'Blend imehifadhiwa kwa mafanikio.',
      blendUploadedToEUSuccessfully: "Blend imepakuliwa kwa mafanikio kwenye EU."
    },
    manageProducts: {
      addNewProduct: 'Ongeza Bidhaa Mpya',
      editProduct: 'Hariri Bidhaa',
      addNewSubProduct: 'Ongeza Bidhaa Ndogo Mpya',
      editSubProduct: 'Hariri Bidhaa Ndogo',
      productTitle: 'Kichwa cha Bidhaa',
      subProductTitle: 'Kichwa cha Bidhaa Ndogo',
      typeTitle: 'Andika Kichwa',
      hsCode: 'Msimbo wa HS',
      typeHSCode: 'Andika Msimbo wa HS',
      eudrDocumentCode: 'Msimbo wa Hati ya EUDR',
      selectEudrDocumentCode: 'Chagua Msimbo wa Hati ya EUDR',
      makeSelection: 'Chagua',
      uploadCategoryImage: 'Pakia Picha ya Jamii',
      addImage: 'Ongeza Picha',
      cancel: 'Ghairi',
      save: 'Hifadhi',
      back: 'Nyuma',
      add: 'Ongeza',
      confirm: 'Thibitisha',
      deleteMessage: 'Je, una uhakika unataka kuondoa',
      invalidFileType: 'Aina ya Faili Si Sahihi',
      errorUploadingFile:
        'Hitilafu isiyotazamiwa ilitokea wakati wa kupakia faili. Tafadhali jaribu tena baadaye.',
      fileUploadFailed: 'Imeshindwa Kupakia Faili',
      selectDocumentCode: 'Chagua Msimbo wa Hati',
      view: 'Tazama',
      edit: 'Hariri',
      remove: 'Ondoa',
      search: 'Tafuta',
      searchByProductName: 'Tafuta kwa Jina la Bidhaa',
      eudrDueDiligence: 'Ufuatiliaji wa EUDR',
      products: 'Bidhaa',
      subProducts: 'Bidhaa Ndogo',
      fieldRequired: 'Sehemu hii inahitajika',
      fileRequired: 'Faili Inahitajika',
      fileRequiredMessage:
        'Tafadhali pakia au chagua faili kabla ya kuhifadhi bidhaa.',
      addNewDocumentCode: 'Ongeza Msimbo wa Hati Mpya',
      enterHere: 'Ingiza hapa',
      documentCode: 'Msimbo wa Hati',
      title: 'Kichwa',
      description: 'Maelezo',
      updateProduct: 'Sasisha Bidhaa',
      updateSubProduct: 'Sasisha Bidhaa Ndogo',
      deleteSubProduct: 'Futa Bidhaa Ndogo',
      deleteProduct: 'Futa Bidhaa',
      productAddedMessage: 'Bidhaa imeongezwa kwa mafanikio.',
      subProductAddedMessage: 'Bidhaa ndogo imeongezwa kwa mafanikio.',
      productUpdateMessage: 'Bidhaa imesasishwa kwa mafanikio.',
      subProductUpdateMessage: 'Bidhaa ndogo imesasishwa kwa mafanikio.',
      subProductDeleteMessage: 'Bidhaa ndogo imefutwa kwa mafanikio.',
      productDeleteMessage: 'Bidhaa imefutwa kwa mafanikio.',
      pleaseTryAgain: 'Kuna hitilafu. Tafadhali jaribu tena baadaye.',
      documentCodeDuplicate: 'Msimbo wa hati tayari upo',
      unsupportedFileFormat: 'Aina ya faili haisaidiwi. Tafadhali pakia faili la picha halali.',
      tableHeaders: {
        productName: 'Jina la Bidhaa',
        hsCode: 'Msimbo wa HS',
        eudrDocumentCode: 'Msimbo wa Hati ya EUDR',
        subProduct: 'Bidhaa Ndogo',
        dateAdded: 'Tarehe Iliyoongezwa',
        action: 'Vitendo',
      },
      documentCodeSaved: 'Msimbo wa Hati umehifadhiwa kwa mafanikio.',
    },
    finalReport: {
      title: 'Ripoti ya Mwisho ya Mchanganyiko',
      reportStatus: 'Hali ya Ripoti',
      blendTitle: 'Kichwa cha Mchanganyiko',
      blendCode: 'Msimbo wa Mchanganyiko',
      finalProduct: 'Bidhaa ya Mwisho',
      finalProductCode: 'Msimbo wa Bidhaa ya Mwisho',
      blendDescription: 'Maelezo ya Mchanganyiko',
      processType: 'Aina ya Mchakato',
      netMass: 'Uzito Halisi',
      volume: 'Kiasi',
      blendLotId: 'ID ya Sehemu ya Mchanganyiko',
      finalProductLotId: 'ID ya Sehemu ya Bidhaa ya Mwisho',
      internalReferenceNumber: 'Nambari ya Marejeo ya Ndani',
      eudrReferenceNumber: 'Nambari ya Marejeo ya EUDR',
      activity: 'Shughuli',
      countryOfActivity: 'Nchi ya Shughuli',
      countryOfEntry: 'Nchi ya Kuingia',
      dueDiligenceReportStatus: 'Hali ya Ripoti ya Ufuatiliaji',
      containerId: 'ID ya Kontena',
      operatorData: 'Data ya Opereta',
      name: 'Jina',
      country: 'Nchi',
      isoCode: 'Msimbo wa ISO',
      eoriNumber: 'Nambari ya EORI',
      reportSummary: {
        title: 'Muhtasari wa Ripoti',
        totalDdsReports: 'Jumla ya Ripoti za DDS',
        totalGeofencePolygons: 'Jumla ya Poligoni za Geofence',
        totalGeofencePoints: 'Jumla ya Pointi za Geofence',
        totalDeforestationAssessments: 'Jumla ya Tathmini za Ukataji Miti',
        totalRiskAssessments: 'Jumla ya Tathmini za Hatari',
        totalFarms: 'Jumla ya Mashamba',
        totalHighDeforestationFarms: 'Mashamba Yenye Ukataji Miti Mkubwa',
        totalLowZeroRiskFarms: 'Mashamba Yenye Hatari Chini au Sifuri',
        totalArea: 'Jumla ya Eneo (ha)',
        averageGeofenceArea: 'Eneo la Kati la Geofence (ha)',
        totalHighRiskFarmArea: 'Jumla ya Eneo la Mashamba ya Hatari Kuu',
        totalLowZeroRiskFarmArea:
          'Jumla ya Eneo la Mashamba Hatari Chini au Sifuri',
        productionPlaces: 'Maeneo ya Uzalishaji',
        productionPlacesTooltip: 'Maelezo kuhusu maeneo ya uzalishaji',
        declarationStatement: 'Tamko la Opereta',
        declarationStatementTooltip: 'Tamko rasmi la opereta',
        declarationText1:
          '[Jina] {name}, ninathibitisha kuwa data zote zilizowasilishwa na usafirishaji huu ni sahihi kulingana na maarifa yangu na imani yangu.',
        declarationText2:
          'Mimi, [Jina] {name}, nathibitisha kuwa nimezuru mashamba yanayohusiana na usafirishaji huu na nathibitisha kufuata kwao sheria na kanuni za ndani zinazohusiana na ukataji miti.',
      },
      blendProducts: {
        title: 'Bidhaa za Mchanganyiko',
        product: 'Bidhaa',
        subProduct: 'Bidhaa Ndogo',
        country: 'Nchi',
        reference: 'EUDR / Nambari ya Marejeo ya Ndani',
        containerId: 'ID ya Kontena',
        farmsQuantity: 'Mashamba & Kiasi',
        submissionDate: 'Tarehe ya Kuwasilisha',
        status: 'Hali',
      },
      activityLog: {
        title: 'Rekodi ya Shughuli',
        user: 'Mtumiaji',
        userRole: 'Nafasi ya Mtumiaji',
        ipAddress: 'Anwani ya IP',
        dateTime: 'Tarehe & Muda',
        segment: 'Sehemu',
        activityDescription: 'Maelezo ya Shughuli',
      },
      declaration: {
        title: 'Tamko la Opereta',
        name: 'Jina',
        address: 'Anwani',
        dateTime: 'Tarehe & Muda',
      },
      buttons: {
        discard: 'Ondoa',
        reject: 'Kataa',
        edit: 'Hariri',
        finalize: 'Maliza',
        download: 'Pakua',
        uploadToEuPortal: 'Pakia kwenye Portal ya EU',
        submit: 'Wasilisha',
      },
    },
  }
};